import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import type { UpdateAdminUserRequest } from '../types/admin-user.types';
import { adminUserKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface UpdateAdminUserParams {
  adminUserId: string;
  data: UpdateAdminUserRequest;
}

/**
 * React Query hook to update an existing admin user
 * Invalidates: ['adminUsers'] queries on success
 */
export const useUpdateAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ adminUserId, data }: UpdateAdminUserParams) =>
      adminUsersApi.updateUser(adminUserId, data),
    onSuccess: () => {
      // Invalidate all admin users queries to refetch the list
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
      Notification.success({
        title: 'Administrador actualizado',
        description: 'El administrador ha sido actualizado exitosamente.',
      });
    },
  });
};
